define('headerView',[
  'module',
  'marionette',
  'app',
  'settings',
  'underscore',
  'headerCompuzzView',
  'headerNotificationsView',
  'headerChatView',
  'headerSalesInboxView',
  'headerTasksView',
  'headerAccountView',
  'headerLanguagesView',
  'headerSearchView',
  'headerUserView',
  'headerUsersView',
  'headerDesignersView',
  'windowsToolsView',
  'headerPhoneView',
  'rolesMixin',
  'secondScreenBridge',
  'template!headerView'
], function(
  Module,
  Marionette,
  App,
  Settings,
  _,
  CompuzzView,
  NotificationsView,
  ChatView,
  SalesInboxView,
  TasksView,
  AccountView,
  LanguagesView,
  SearchView,
  UserView,
  UsersView,
  DesignersView,
  WindowsToolsView,
  PhoneView,
  RolesMixin,
  SecondScreen,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'main-header-view',
    tagName: 'header',

    events: {
      'click .sidebar-toggle': 'onToggleSidebar',
      'click .theme-toggle': 'onToggleTheme',
      'click .second-screen-toggle': 'onToggleSecondScreen'
    },

    regions: {
      compuzzRegion: '.compuzz-region', 
      accountRegion: '.account-region',     
      languagesRegion: '.languages-region', 
      searchRegion: '.search-region',
      notificationsRegion: '.notifications-region',
      chatRegion: '.chat-region',
      salesInboxRegion: '.sales-inbox-region',
      tasksRegion: '.tasks-region',
      phoneRegion: '.phone-region',
      userRegion: '.user-region',
      usersRegion: '.users-region',
      designersRegion: '.designers-region',
      windowsToolsRegion: '.windows-tools-region'
    },

    onToggleSidebar: function () {
      App.trigger('sidebar:switch');
    },

    /**
     * Toggle dark mode on/off. The class lives on <body> so it can scope
     * the dark-mode SCSS without touching every component selector; the
     * preference is persisted so it survives navigation and reloads.
     * `main.js` re-applies the class at app boot to avoid a light-mode
     * flash for returning users.
     */
    onToggleTheme: function () {
      var enabled = document.body.classList.toggle('dark-mode');
      try {
        window.localStorage.setItem('compuzz-dark-mode', enabled ? '1' : '0');
      } catch (e) { /* storage disabled — preference just won't persist */ }
    },

    /**
     * Mark / unmark THIS browser tab as the "second screen" — the single tab
     * that second-screen shortcuts (from the Sales Inbox) drive. Only one tab
     * is the target at a time; marking this one releases any other. The button
     * reflects cross-tab changes via the App-level 'secondScreen:targetChanged'
     * event (raised locally and on the storage event from other tabs).
     */
    onToggleSecondScreen: function () {
      this.updateSecondScreenTarget(SecondScreen.toggleTarget());
    },

    updateSecondScreenTarget: function (isTarget) {
      var $btn = this.$('.second-screen-toggle');
      $btn.toggleClass('is-target', !!isTarget);
      $btn.attr('title', isTarget ?
        _.i18n('header.secondScreen.active', null, 'This tab is the second screen — shortcuts open here. Click to release.') :
        _.i18n('header.secondScreen.activate', null, 'Use this tab as the second screen for Sales Inbox shortcuts.'));
    },

    serializeData: function () {
      return {
        displayTasks: (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_TASKS]),
        displayNotifications: (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_TASKS]),
        displayChat: (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_CHAT_INBOX]),
        displaySalesInbox: (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_SALES_INBOX]),
        advancedMode: (Settings.configValue('advancedMode') === true)
      };
    },

    onShow: function () {
      this.compuzzView = new CompuzzView();     
      this.getRegion('compuzzRegion').show(this.compuzzView);

      this.accountView = new AccountView();     
      this.getRegion('accountRegion').show(this.accountView);

      this.languagesView = new LanguagesView();     
      this.getRegion('languagesRegion').show(this.languagesView);

      this.userView = new UserView();     
      this.getRegion('userRegion').show(this.userView);      

      if (Settings.configValue('advancedMode') === true) {
        this.usersView = new UsersView();
        this.getRegion('usersRegion').show(this.usersView);
        this.usersView.on('closeAllPopups', _.bind(function () {   
          if (this.notificationsView)
            this.notificationsView.close();
         
          if (this.usersView)
            this.usersView.close();
        }, this));

        this.designersView = new DesignersView();
        this.getRegion('designersRegion').show(this.designersView);
      }

      this.searchView = new SearchView();
      this.getRegion('searchRegion').show(this.searchView);

      this.windowsToolsView = new WindowsToolsView();
      this.getRegion('windowsToolsRegion').show(this.windowsToolsView);
    
      if (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_CHAT_INBOX]) {
        this.chatView = new ChatView();
        this.getRegion('chatRegion').show(this.chatView);
      }

      if (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_SALES_INBOX]) {
        this.salesInboxView = new SalesInboxView();
        this.getRegion('salesInboxRegion').show(this.salesInboxView);
      }

      if (Settings.get('cAccountRoles')[RolesMixin.DASHBOARD_TASKS]) {
        this.notificationsView = new NotificationsView();
        this.getRegion('notificationsRegion').show(this.notificationsView);
        this.notificationsView.on('closeAllPopups', _.bind(function() {         
          if (this.tasksView)
            this.tasksView.close();

          if (this.usersView)
            this.usersView.close();
        }, this));

        this.tasksView = new TasksView();
        this.getRegion('tasksRegion').show(this.tasksView);
        this.tasksView.on('closeAllPopups', _.bind(function () {   
          if (this.notificationsView)
            this.notificationsView.close();
       
          if (this.usersView)
            this.usersView.close();
        }, this));
      }

      if (Settings.configValue('advancedMode') === true) {
        this.phoneView = new PhoneView();
        this.getRegion('phoneRegion').show(this.phoneView);
      }

      // Second-screen targeting is an advanced-mode-only feature; the toggle
      // is rendered only in advanced mode, so only wire it up there too.
      if (Settings.configValue('advancedMode') === true) {
        // Reflect this tab's second-screen target state, and keep the toggle in
        // sync when another tab claims/releases the target.
        this.updateSecondScreenTarget(SecondScreen.isTarget());
        this.listenTo(App, 'secondScreen:targetChanged', this.updateSecondScreenTarget);
      }
    }
  });
});
